import * as r from 'ramda';
import { handleActions } from 'redux-actions';

import * as actions from '../actions';

const InitialState = null;

export const selectedPublisherIdReducer = handleActions(
  {
    [actions.setCurrentUser]: (currentPublisherId, { payload: user }) => {
      if (currentPublisherId) {
        return currentPublisherId;
      }

      const { Publishers: publishersIds } = user;
      return r.head(publishersIds);
    },

    [actions.selectPublisherId]: (state, { payload: publisherId }) => publisherId,
  },
  InitialState
);
